import { Component } from "@theme/component";
import { onAnimationEnd } from "@theme/utilities";

/**
 * Custom code: toast
 * A custom element that manages a toast.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} toast – The toast element.
 * @property {HTMLElement} content – The toast content element.
 *
 * @extends Component<Refs>
 */
export class ToastComponent extends Component {
  requiredRefs = ["toast", "content"];

  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  showToast() {
    const { toast } = this.refs;

    if (toast.dataset.shown === "true") return;

    if (this.refs.content.innerHTML.trim() === "") {
      toast.dataset.shown = "false";
      return;
    }

    requestAnimationFrame(() => {
      toast.dataset.shown = "true";
    });
  }

  closeToast = async () => {
    const { toast } = this.refs;

    if (toast.dataset.shown !== "true") return;

    toast.style.animation = "none";

    void toast.offsetWidth;

    toast.classList.add("toast-closing");
    toast.style.animation = "";

    await onAnimationEnd(toast, undefined, {
      subtree: false,
    });

    toast.dataset.shown = "false";
    toast.classList.remove("toast-closing");
  };
}

if (!customElements.get("toast-component"))
  customElements.define("toast-component", ToastComponent);
